import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-draw';

const GeoZonasLogic = () => {
  const map = useMap();

  useEffect(() => {
    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);

    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: drawnItems,
      },
      draw: {
        polygon: true,
        rectangle: true,
        circle: true,
        marker: false,
        polyline: false,
      },
    });

    map.addControl(drawControl);

    const guardarZona = async (data) => {
      try {
        const res = await fetch('http://localhost:3000/api/geozonas/crear', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });

        const resultado = await res.json();
        if (resultado.ok) {
          alert('✅ Zona guardada exitosamente');
        } else {
          alert('❌ Error al guardar zona');
        }
      } catch (error) {
        console.error('❌ Error al guardar zona:', error);
        alert('❌ Error de red al guardar zona');
      }
    };

    map.on(L.Draw.Event.CREATED, (event) => {
      const layer = event.layer;
      drawnItems.addLayer(layer);

      const nombre = prompt('Nombre de la zona:');
      if (!nombre) return;

      if (layer instanceof L.Circle) {
        const center = layer.getLatLng();
        const radius = layer.getRadius();

        guardarZona({
          nombre,
          tipo: 'circulo',
          centro_lat: center.lat,
          centro_lng: center.lng,
          radio: radius,
          coordenadas: null,
        });
      } else if (layer instanceof L.Polygon || layer instanceof L.Rectangle) {
        const latlngs = layer.getLatLngs()[0].map((p) => ({
          lat: p.lat,
          lng: p.lng,
        }));

        guardarZona({
          nombre,
          tipo: 'poligono',
          centro_lat: null,
          centro_lng: null,
          radio: null,
          coordenadas: latlngs,
        });
      }
    });

    // Atajo de teclado Ctrl + L para iniciar dibujo de polígono
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 'l') {
        const polygonDrawer = new L.Draw.Polygon(map, drawControl.options.draw.polygon);
        polygonDrawer.enable();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      map.removeLayer(drawnItems);
      map.removeControl(drawControl);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [map]);

  return null;
};

export default GeoZonasLogic;
